import { fetchData } from "./fetchData";

export const getLiveTrackTableData = async(runID) => {
    const route = `/livetracks?runid=${runID}`;

    const options = {
        method: 'GET'
    }

    let response = await fetchData(route, options);

    return response;
}

export const updatePasstimeAndSpeed = async(altID, altItem, initialLaunch = false) => {
    const route = `/livetracks/${altID}?initialLaunch=${initialLaunch}`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(altItem)
    }

    let response = await fetchData(route, options);

    return response;
}

export const checkLiveTrackForUpdatesAPI = async(updateTime, runID) => {
    const route = `/livetracks/updates?runid=${runID}&lastupdate=${updateTime}`;

    const options = {
        method: 'GET'
    }

    let response = await fetchData(route, options);

    return response;
}

export const launchPigAPI = async(runID) => {
    const route = `/livetracks/launchpig?runid=${runID}`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        }    
    }

    let response = await fetchData(route, options);

    return response;
}

export const approveSpeedAPI = async(approvalData) => {
    const route = `/livetracks/approvespeed`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(approvalData)
    }

    let response = await fetchData(route, options);

    return response;
}

export const approveSpeedInAppAPI = async(approvalData) => {
    const route = `/livetracks/approvespeed-in-app`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(approvalData)
    }

    let response = await fetchData(route, options);

    return response;
}

//pause/unpause notifications for run

export const pauseNotificationsAPI = async(RunID) => {
    const route = `/livetracks/pause-notifications/${RunID}`;

    const options = {
        method: 'PUT',
    }

    let response = await fetchData(route, options);

    return response;
}

export const unpauseNotificationsAPI = async(RunID) => {
    const route = `/livetracks/unpause-notifications/${RunID}`;

    const options = {
        method: 'PUT',
    }

    let response = await fetchData(route, options);

    return response;
}

export const getSpeedApprovalsAPI = async(JobID, RunID = null, UserID = null) => {
    let route = `/livetracks/list-speed-approvals?jobid=${JobID}`;

    if (RunID) {
        route += `&runid=${RunID}`;
    }

    if(UserID){
        route += `&userid=${UserID}`;
    }

    const options = {
        method: 'GET'
    }

    let response = await fetchData(route, options);

    return response;
}